var styles = {"root":"Chip-module_root__mM_YY","primary":"Chip-module_primary__1aOwp","outlined":"Chip-module_outlined__2zM3c","filled":"Chip-module_filled__ouvkT","success":"Chip-module_success__xgbX6","info":"Chip-module_info__32q3G","default":"Chip-module_default__2FsOy","pilled":"Chip-module_pilled__35oPO","rounded":"Chip-module_rounded__DpCE2"};

export { styles as default };
//# sourceMappingURL=Chip.module.css.js.map
